module.exports = __webpack_public_path__ + "media/Step1.8fc9b5e5.webm";